import {
  ChangeDetectionStrategy,
  Component,
  input
} from '@angular/core';

@Component({
  selector: 'app-full-screen-loader',
  templateUrl: './full-screen-loader.html',
  styleUrls: ['./full-screen-loader.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FullScreenLoaderComponent {
  readonly loaderText = input.required<string>();
}
